import React, { useState } from 'react'
import AuditDashboardSearchForm from './AuditDashboardSearchForm'
import SummaryOfGradeChart from './SummaryOfGradeChart'
import SummaryOf5YearChart from './SummaryOf5YearChart'
import SummaryOfIssueCategoryChart from './SummaryOfIssueCategoryChart'
import SummaryOfDepartmentChart from './SummaryOfDepartmentChart'
import SummaryOfStatus from './SummaryOfStatus'
import SummaryOfRiskChart from './SummaryOfRiskChart'
import SummaryOfIssue from './SummaryOfIssue'
import SummaryOfIssueWidget from './SummaryOfIssueWidget'

export default function AuditDashboardWidget(props) {
  const { schema } = props

  // const [isLoading, setIsLoading] = useState(false)
  const [request, setRequest] = useState(schema?.budgetYear)
  const [isRefash, setIsRefash] = useState(false)

  const handleSearch = async (request) => {
    setRequest(request)
    onRefash()
  }
  const handleCancle = async (request) => {
    setRequest(request)
    onRefash()
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      {schema?.searchForm && (
        <div style={{ marginTop: 0 }}>
          <AuditDashboardSearchForm
            schema={schema.searchForm}
            onSearch={handleSearch}
            onCancle={handleCancle}
            // loading={isLoading}
          />
        </div>
      )}

      {!isRefash && (
        <>
          {schema?.panels?.map((e) => {
            let panel
            switch (e) {
              case 'summaryOfStatus':
                panel = <SummaryOfStatus request={request} />
                break
              case 'summaryOfGrade':
                panel = <SummaryOfGradeChart request={request} />
                break
              case 'summaryOf5Year':
                panel = <SummaryOf5YearChart request={request} />
                break
              case 'summaryOfIssueCategory':
                panel = <SummaryOfIssueCategoryChart request={request} />
                break
              case 'summaryOfProject':
                panel = <SummaryOfDepartmentChart request={request} />
                break
              // case 'summaryOfRisk':
              //   panel = <SummaryOfRiskChart request={request} />
              //   break
              case 'summaryOfIssue':
                panel = <SummaryOfIssueWidget budgetYear={request} />
                break
              // case 'summaryOfIssueCP':
              //   panel = <SummaryOfIssue request={request} isSolve={true} />
              //   break
              default:
                break
            }

            return panel
          })}
        </>
      )}
    </>
  )
}
